import React from 'react';

function OutlookMark({ width = 20, height = 20 }) {
    return (
        <svg viewBox="0 0 32 32" width={width} height={height} aria-hidden="true">
            <rect x="2" y="6" width="28" height="20" rx="3" fill="#fff"/>
            <path d="M2 9l14 9 14-9" stroke="#0078d4" strokeWidth="2" fill="none"/>
            <text x="6" y="22" fontFamily="Arial" fontWeight="bold" fontSize="11" fill="#0078d4">O</text>
        </svg>
    );
}

export default OutlookMark;
